export default __webpack_public_path__ + "static/bannerPubli-CL-9c1812cbcefe5234ffc8d52e558b92a7.png";